import { render, staticRenderFns } from "./VerifyCodeEmail.vue?vue&type=template&id=18123780&scoped=true&"
import script from "./VerifyCodeEmail.vue?vue&type=script&lang=js&"
export * from "./VerifyCodeEmail.vue?vue&type=script&lang=js&"
import style0 from "./VerifyCodeEmail.vue?vue&type=style&index=0&id=18123780&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18123780",
  null
  
)

export default component.exports